<div class="auth-loader">
    <h2>Please Stand By...</h2>
    <loading [cover]="false"></loading>
</div>
